<div class="status-chip"
     [style.background-color]="bg_color"
     [style.color]="text_color"
>{{label}}</div>
